import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { FaChevronLeft, FaChevronRight, FaTimes } from "react-icons/fa";
import { GrGallery } from "react-icons/gr";

import img1 from "../imgs/Galleria/orchestra01_sito.jpg";
import img2 from "../imgs/Galleria/orchestra05_sito.jpg";
import img3 from "../imgs/Galleria/orchestra04_sito.jpg";
import img4 from "../imgs/Galleria/ottoni_sito.jpg";
import img5 from "../imgs/Galleria/sezione01_sito.jpg";
import img6 from "../imgs/Galleria/sezione02_sito.jpg";
import img7 from "../imgs/Galleria/foto01.jpg";
import img8 from "../imgs/Galleria/NOM_04_risultato.jpg";
import img10 from "../imgs/Galleria/NOM_06_risultato.jpg";
import img11 from "../imgs/Galleria/NOM_08_risultato.jpg";
import img12 from "../imgs/Galleria/NOM_11_risultato.jpg";
import img13 from "../imgs/Galleria/NOM_13_risultato.jpg";
import img14 from "../imgs/Galleria/NOM_16_risultato.jpg";
import img15 from "../imgs/Galleria/NOM_20_risultato.jpg";
import img17 from "../imgs/Galleria/NOM_24_risultato.jpg";
import img18 from "../imgs/Galleria/NOM_25_risultato.jpg";
import img19 from "../imgs/Galleria/NOM_26_risultato.jpg";
import img20 from "../imgs/Galleria/NOM_29_risultato.jpg";
import img21 from "../imgs/Galleria/NewGallery (1).jpg";
import img22 from "../imgs/Galleria/NewGallery (2).jpg";
import img23 from "../imgs/Galleria/NewGallery (3).jpg";
import img24 from "../imgs/Galleria/NewGallery (4).jpg";
import img25 from "../imgs/Galleria/NewGallery (5).jpg";
import img26 from "../imgs/Galleria/NewGallery (6).jpg";
import img27 from "../imgs/Galleria/NewGallery (7).jpg";
import img28 from "../imgs/Galleria/NewGallery (8).jpg";
import img29 from "../imgs/Galleria/NewGallery (9).jpg";
import img30 from "../imgs/Galleria/NewGallery (10).jpg";
import img31 from "../imgs/Galleria/NewGallery (11).jpg";
import img32 from "../imgs/Galleria/NewGallery (12).jpg";
import img33 from "../imgs/Galleria/NewGallery (13).jpg";
import img34 from "../imgs/Galleria/NewGallery(14).jpg";
import img35 from "../imgs/Galleria/NewGallery(15).jpg";
import Uttaro1 from "../imgs/Galleria/Uttaro_Alessandro_OrchestraMilarte_13dicembre2024-1.jpg";
import Uttaro2 from "../imgs/Galleria/Uttaro_Alessandro_OrchestraMilarte_13dicembre2024-2.jpg";
import Uttaro3 from "../imgs/Galleria/Uttaro_Alessandro_OrchestraMilarte_13dicembre2024-3.jpg";
// import Uttaro4 from "../imgs/Galleria/Uttaro_Alessandro_OrchestraMilarte_13dicembre2024-4.jpg";
import Uttaro5 from "../imgs/Galleria/Uttaro_Alessandro_OrchestraMilarte_13dicembre2024-5.jpg";
import Uttaro6 from "../imgs/Galleria/Uttaro_Alessandro_OrchestraMilarte_13dicembre2024-6.jpg";
import Uttaro8 from "../imgs/Galleria/Uttaro_Alessandro_OrchestraMilarte_13dicembre2024-8.jpg";
import Uttaro9 from "../imgs/Galleria/Uttaro_Alessandro_OrchestraMilarte_13dicembre2024-9.jpg";
import Uttaro10 from "../imgs/Galleria/Uttaro_Alessandro_OrchestraMilarte_13dicembre2024-10.jpg";
import Uttaro11 from "../imgs/Galleria/Uttaro_Alessandro_OrchestraMilarte_13dicembre2024-11.jpg";
import Uttaro12 from "../imgs/Galleria/Uttaro_Alessandro_OrchestraMilarte_13dicembre2024-12.jpg";
import Uttaro13 from "../imgs/Galleria/Uttaro_Alessandro_OrchestraMilarte_13dicembre2024-13.jpg";
import Uttaro14 from "../imgs/Galleria/Uttaro_Alessandro_OrchestraMilarte_13dicembre2024-14.jpg";
import Uttaro15 from "../imgs/Galleria/Uttaro_Alessandro_OrchestraMilarte_13dicembre2024-15.jpg";
import Uttaro17 from "../imgs/Galleria/Uttaro_Alessandro_OrchestraMilarte_13dicembre2024-17.jpg";
import Uttaro18 from "../imgs/Galleria/Uttaro_Alessandro_OrchestraMilarte_13dicembre2024-18.jpg";
import Uttaro19 from "../imgs/Galleria/Uttaro_Alessandro_OrchestraMilarte_13dicembre2024-19.jpg";
import Uttaro20 from "../imgs/Galleria/Uttaro_Alessandro_OrchestraMilarte_13dicembre2024-20.jpg";
import Uttaro21 from "../imgs/Galleria/Uttaro_Alessandro_OrchestraMilarte_13dicembre2024-21.jpg";
import Uttaro22 from "../imgs/Galleria/Uttaro_Alessandro_OrchestraMilarte_13dicembre2024-22.jpg";
import Uttaro23 from "../imgs/Galleria/Uttaro_Alessandro_OrchestraMilarte_13dicembre2024-23.jpg";
import Uttaro25 from "../imgs/Galleria/Uttaro_Alessandro_OrchestraMilarte_13dicembre2024-25.jpg";
import Uttaro26 from "../imgs/Galleria/Uttaro_Alessandro_OrchestraMilarte_13dicembre2024-26.jpg";
import Uttaro27 from "../imgs/Galleria/Uttaro_Alessandro_OrchestraMilarte_13dicembre2024-27.jpg";
import Uttaro28 from "../imgs/Galleria/Uttaro_Alessandro_OrchestraMilarte_13dicembre2024-28.jpg";

const NewGallery = () => {
  const immagini = [
    Uttaro1,
    Uttaro2,
    Uttaro3,
    // Uttaro4,
    Uttaro5,
    Uttaro6,
    // Uttaro7,
    Uttaro8,
    Uttaro9,
    Uttaro10,
    Uttaro11,
    Uttaro12,
    Uttaro13,
    Uttaro14,
    Uttaro15,
    Uttaro17,
    Uttaro18,
    Uttaro19,
    Uttaro20,
    Uttaro21,
    Uttaro22,
    Uttaro23,
    // Uttaro24,
    Uttaro25,
    Uttaro26,
    Uttaro27,
    Uttaro28,
    img35,
    img7,
    img21,
    img22,
    img23,
    img24,
    img25,
    img26,
    img27,
    img28,
    img29,
    img30,
    img31,
    img32,
    img33,
    img34,
    img1,
    img2,
    img3,
    img4,
    img5,
    img6,
    img8,
    img10,
    img11,
    img12,
    img13,
    img14,
    img15,
    img17,
    img18,
    img19,
    img20,
  ];

  const [selectedImage, setSelectedImage] = useState(null);
  const [paginaCorrente, setPaginaCorrente] = useState(1);
  const immaginiPerPagina = 12;

  const indiceUltimaImmagine = paginaCorrente * immaginiPerPagina;
  const indicePrimaImmagine = indiceUltimaImmagine - immaginiPerPagina;
  const immaginiCorrenti = immagini.slice(
    indicePrimaImmagine,
    indiceUltimaImmagine
  );
  const numeroTotalePagine = Math.ceil(immagini.length / immaginiPerPagina);

  const scrollUp = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth", // puoi togliere "smooth" se vuoi che sia immediato
    });
  };
  // Precaricamento immagini
  useEffect(() => {
    immagini.forEach((src) => {
      const img = new Image();
      img.src = src;
    });
  }, [immagini]);

  return (
    <div className="bg-gradient-to-r from-white to-amber-50 min-h-screen flex flex-col items-center pb-10">
      <GrGallery className="fixed text-amber-200/40 text-[180px] rotate-12 -top-5 -right-5 z-0" />
      <h2 className="text-red-600 font-extrabold text-3xl md:text-4xl mt-5 tracking-wide z-10">
        GALLERIA
      </h2>

      {/* 📸 Griglia immagini */}
      <div className="mt-5 px-4 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-5 max-w-7xl z-10">
        {immaginiCorrenti.map((immagine, index) => (
          <motion.div
            key={index}
            className="relative overflow-hidden rounded-xl shadow-md cursor-pointer"
            whileHover={{ scale: 1.03 }}
            transition={{ duration: 0.3 }}
            onClick={() => setSelectedImage(immagine)}
          >
            <img
              src={immagine}
              alt={`Immagine ${index}`}
              className="w-full h-60 object-cover transition-transform duration-300 hover:scale-105"
              loading="lazy"
            />
          </motion.div>
        ))}
      </div>

      {/* 🔄 Navigazione tra pagine */}
      <div className="flex justify-center items-center gap-6 mt-10 z-10">
        <button
          onClick={() => {
            setPaginaCorrente((prev) => Math.max(prev - 1, 1));
            scrollUp();
          }}
          // disabled={paginaCorrente === 1}
          className={`p-3 rounded-full shadow-md transition-all ${
            paginaCorrente === 1
              ? "bg-gray-200 cursor-not-allowed"
              : "bg-red-600 hover:bg-red-700 text-white"
          }`}
        >
          <FaChevronLeft />
        </button>

        <span className="text-gray-600 font-medium text-lg">
          Pagina {paginaCorrente} di {numeroTotalePagine}
        </span>

        <button
          onClick={() => {
            setPaginaCorrente((prev) => Math.min(prev + 1, numeroTotalePagine));
            scrollUp();
          }}
          // disabled={paginaCorrente === numeroTotalePagine}
          className={`p-3 rounded-full shadow-md transition-all ${
            paginaCorrente === numeroTotalePagine
              ? "bg-gray-200 cursor-not-allowed"
              : "bg-red-600 hover:bg-red-700 text-white"
          }`}
        >
          <FaChevronRight />
        </button>
      </div>

      {/* 🌙 Lightbox */}
      <AnimatePresence>
        {selectedImage && (
          <motion.div
            className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-50 backdrop-blur-sm"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() => setSelectedImage(null)}
          >
            <motion.div
              className="relative p-4"
              initial={{ scale: 0.95 }}
              animate={{ scale: 1 }}
              exit={{ scale: 0.95 }}
              onClick={(e) => e.stopPropagation()}
            >
              <button
                className="absolute top-0 right-0 m-4 bg-white text-red-700 p-2 rounded-full shadow-lg hover:bg-red-100 transition"
                onClick={() => setSelectedImage(null)}
              >
                <FaTimes size={18} />
              </button>
              <img
                src={selectedImage}
                alt="Immagine selezionata"
                className="max-h-[85vh] max-w-[90vw] rounded-lg object-contain"
              />
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default NewGallery;
